// test1160
(1160 && 0);
